import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SubscriptionFailed from "../components/Subscription/Failed";
import SubscriptionSuccess from "../components/Subscription/Success";
import { transactionService } from "../services";

const useQuery = () => new URLSearchParams(useLocation().search);

const Subscription = () => {
  const query = useQuery();
  const paymentReference = query.get("paymentReference");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage]=useState("")
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        const res = await transactionService.verifyTransaction(
          paymentReference
        );
        if (res.paid) {
          console.log("Payment verified successfully!");
          setVerified(true);
        }
      } catch (error) {
        setErrorMessage(error.message)
        setError(true);
      }
    };
    verifyPayment();
  }, [paymentReference]);

  if (!verified && !error) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <p className="text-yellow-500 text-xl">
          Verifying your subscription...
        </p>
      </div>
    );
  }

  if (error) return <SubscriptionFailed message={errorMessage} />;

  if (verified) return <SubscriptionSuccess />;
};

export default Subscription;
